import {z} from 'zod';

import {BaseVoidRequestSchema} from '@dms/api/shared';

const BaseServiceOrderVariantSchema = z.object({
  id: z.string(),
  isActive: z.boolean(),
  authorizationProfileId: z.string(),
  serviceCaseTypeId: z.string(),
  serviceOrderTypeId: z.string(),
  name: z.string(),
  note: z.string().nullish(),
  priceType: z.string(),
  priceTypeRatio: z.number(),
  rateType: z.string(),
  rateTypeRatio: z.number(),
  isUnitPriceWithVat: z.boolean(),
  defaultCustomerId: z.string().nullish(),
  isChangeableDefaultCustomer: z.boolean(),
  suffix: z.string().nullish(),
  minimalMaterialMargin: z.number().nullish(),
  minimalWorkMargin: z.number().nullish(),
  isDefaultForServiceCaseType: z.boolean(),
  isCancelReasonRequired: z.boolean(),
});
export type BaseServiceOrderVariant = z.infer<typeof BaseServiceOrderVariantSchema>;

/**
 * GET
 */
export const GetServiceOrderVariantsRequestSchema = BaseVoidRequestSchema;
export type GetServiceOrderVariantsRequest = z.infer<typeof GetServiceOrderVariantsRequestSchema>;

export const GetServiceOrderVariantsResponseSchema = z.array(
  BaseServiceOrderVariantSchema.nullable()
);
export type GetServiceOrderVariantsResponse = z.infer<typeof GetServiceOrderVariantsResponseSchema>;
